import React from 'react';
import i18n from 'i18next';
import ErrorIcon from './icons/Circle-x.svg';
import CircleCheck from './icons/CircleCheck.svg';
import CSVIcon from './icons/CSV.svg';
import DeleteIcon from './icons/Delete.svg';
import DocumentIcon from './icons/Document.svg';
import DocumentSearch from './icons/DocumentSearch.svg';
import DownloadIcon from './icons/Download.svg';
import ExcelIcon from './icons/Excel.svg';
import Lender from './icons/Lender.svg';
import List from './icons/List.svg';
import OneNoteIcon from './icons/OneNote.svg';
import SecurityAlert from './icons/SecurityAlert.svg';
import WordIcon from './icons/Word.svg';

export type HbtIconProps = {
  type: string;
};

export const HbtIcon: React.FC<HbtIconProps> = ({ type }: HbtIconProps) => {
  const iconLookup: { [lookupKey: string]: JSX.Element } = {
    file_word: <img src={WordIcon} alt={i18n.t('IconAlt-file-word')} />,
    file_excel: <img src={ExcelIcon} alt={i18n.t('IconAlt-file-excel')} />,
    file_oneNote: <img src={OneNoteIcon} alt={i18n.t('IconAlt-file-oneNote')} />,
    file_generic: <img src={DocumentIcon} alt={i18n.t('IconAlt-file-generic')} />,
    icon_download: <img src={DownloadIcon} alt={i18n.t('IconAlt-download')} />,
    icon_delete: <img src={DeleteIcon} alt={i18n.t('IconAlt-delete')} />,
    icon_csv: <img src={CSVIcon} alt={i18n.t('IconAlt-CSV')} />,
    icon_pdf: (
      <span
        className="material-icons align-self-center icon--size-40"
        role="img"
        aria-label={i18n.t('IconAlt-pdf')}
      >
        picture_as_pdf
      </span>
    ),
    icon_jpeg: (
      <span
        className="material-icons align-self-center icon--size-40"
        role="img"
        aria-label={i18n.t('IconAlt-jpeg')}
      >
        image
      </span>
    ),
    icon_error: <img src={ErrorIcon} alt={i18n.t('Icon-Error')} />,
    icon_documentSearch: <img src={DocumentSearch} alt={i18n.t('Icon-DocumentSearch')} />,
    icon_list: <img src={List} alt={i18n.t('Icon-List')} />,
    icon_securityAlert: <img src={SecurityAlert} alt={i18n.t('Icon-SecuityAlert')} />,
    icon_circleCheck: <img src={CircleCheck} alt={i18n.t('CircleCheck')}></img>,
    icon_lender: <img src={Lender} alt={i18n.t('Lender')}></img>
  };

  return iconLookup[type] ?? null;
};
